if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const prevArrowHTML =
    `<button class="slick-arrow slick-prev" aria-label="Prev">
        <svg width="30" height="10" viewBox="0 0 30 10"><path fill="none" stroke-width="1" stroke="currentColor" d="M 5 1 L 1 5.5 L 5 10 M 1 5.5 H 30" /></svg>
        <span>Prev</span>
    </button>`;
const nextArrowtHTML =
    `<button class="slick-arrow slick-next" aria-label="Next">
        <svg width="30" height="10" viewBox="0 0 30 10"><path fill="none" stroke-width="1" stroke="currentColor" d="M 25 1 L 29 5.5 L 25 10 M 29 5.5 H 0" /></svg>
        <span>Next</span>
    </button>`;

const slickOptions = {
    accessibility: false,
    prevArrow: prevArrowHTML,
    nextArrow: nextArrowtHTML
};

(function(){

    // RESTAURANT-MENU-ALT CATEGORIES ACCORDION
    document.querySelectorAll('.restMenusAlt').forEach(rmenu => {
        rmenu.querySelectorAll('.restMenusAlt_cat-name').forEach(catName => {
            catName.addEventListener('click', e => {
                rmenu.querySelectorAll('.restMenusAlt_cat').forEach(category => {
                    if (catName.parentNode !== category) category.classList.remove('cat-active');
                });
                catName.parentNode.classList.toggle('cat-active');
            });
        });
    });


    // VIDEO SHORTCODE PLAY/PAUSE
    document.querySelectorAll('.videoMod').forEach(mod => {
        mod.querySelector('.videoMod_wrap').addEventListener('click', () => {
            if ( mod.querySelector('video').paused ) {
                mod.querySelector('video').play();
                mod.classList.add('playing');
            } else {
                mod.querySelector('video').pause();
                mod.classList.remove('playing');
            }
        });
    });

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick( slickOptions );

    $('.js-slick-dots').each((i, dots) => {
        $('button', dots).click((e) => {
            let slideTo = $(e.currentTarget).data('goto');
            $(dots).closest('.slick-slider').slick('slickGoTo', slideTo);
        });
    });

    $('.js-slick-prev').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickPrev');
    });

    $('.js-slick-next').click(function () {
        const $curSlider = $(this).data('target') ? $( $(this).data('target') ) : $(this).closest('.sym-slides');
        $curSlider.slick('slickNext');
    });


})();